import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NoDivisionErrorPageComponent } from './no-division-error-page.component';
import { TranslationModule } from '../shared/translation/translation.module';

@NgModule({
  imports: [
    CommonModule,
    TranslationModule
  ],
  declarations: [NoDivisionErrorPageComponent]
})
export class NoDivisionErrorPageModule { }
